
import { Options, Vue } from "vue-class-component"; //基本需要\
import { reactive, ref } from "vue";
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import Bs from "@/components/WorkBench/SideMenu1.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  readPerfReport,
  readRecentTaskrecord,
  readPerformanceVersion,
  readGetPkgResourceList,
  readGetPkgResourceReport,
  readGetPkgResourceSum,
  readGetPkgResourceRate,
  readGetPkgStructTrend,
  readGetPkgMapStructStackOption,
  readGetPkgMapStructTrend,
  readGetPkgAbnormaTrend,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  dispatchGetPerfReportSpeedm,
  dispatchGetReportDetail,
  // dispatchGetPerformances,
  dispatchSendSpeedmReport,
  dispatchtaskRecordDevices,
  dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList,
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchUpdateReport,
  dispatchReportCPUMark,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
  dispatchPkgResourceList,
  dispatchPkgResourceReport,
  dispatchUploadPkgReport,
  dispatchPkgResourceSum,
  dispatchPkgTypeRate,
  dispatchPkgStructTrend,
  dispatchPkgMapStructStackOption,
  dispatchPkgMapStructStack,
  dispatchPkgMapStructTrend,
  dispatchAbnormalTrend,
  dispatchPkgResourceAbnormalList,
  dispatchPkgResourceAbnormalFile,
  dispatchPutAabnormalResourceList,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";
import fileSaver from "file-saver";

// 导入组件SideMenu:2
@Options({
  components: {
    Bs,
  },
})
export default class TestReport extends Vue {
  //声明属性
  public get map_options() {
    return readGetPkgMapStructStackOption(store);
  }
  public get threadTrendData() {
    return readGetPkgAbnormaTrend(store).trend_data;
  }
  public thread_trend_loading = false;
  public thread_max_loading = false;
  public thread_vedio_loading = false;
  public inputValue2 = "";
  public inputValue3 = "";
  public big_page = 1;
  public big_size = 10;
  public video_page = 1;
  public video_size = 10;
  public async thread_trend_api() {
    await dispatchAbnormalTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
    });
    this.drawThreadTrend();
    this.thread_trend_loading = false;
  }
  public max_table = [];
  public max_total = 0;
  public vedio_table = [];
  public vedio_total = 0;
  public async table_thread_max_api() {
    let data = await dispatchPkgResourceAbnormalList(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      page: this.big_page,
      size: this.big_size,

      search: this.inputValue2,
      type: "MaxFile",
      is_ignore: this.big_is_ignore,
    });
    data.results.forEach((v) => {
      if (v.is_ignore) {
        v.check = true;
      } else {
        v.check = false;
      }
    });
    this.max_table = data.results;
    console.log(this.max_table);
    this.max_total = data.count;
    this.thread_max_loading = false;
  }
  public maxChange(type) {
    this.thread_max_loading = true;
    if (type) {
      this.big_page = 1;
    }
    this.table_thread_max_api();
  }
  public videoChange(type) {
    this.thread_vedio_loading = true;
    if (type) {
      this.video_page = 1;
    }
    this.table_thread_video_api();
  }
  public async exportMax() {
    let responseContent = await dispatchPkgResourceAbnormalFile(store, {
      project: this.localProject,
      id_test: Number(this.id_test),

      type: "MaxFile",
      is_ignore: this.big_is_ignore,
    });
    const blob = new Blob([responseContent], {
      type: "text/plain;charset=utf-8",
    });

    // 使用 FileSaver.js 保存 Blob 对象为文件
    fileSaver(blob, "超大资源.txt");
  }
  public async exportVedio() {
    let responseContent = await dispatchPkgResourceAbnormalFile(store, {
      project: this.localProject,
      id_test: Number(this.id_test),

      type: "MaxWiseFile",
      is_ignore: this.vedio_is_ignore,
    });
    const blob = new Blob([responseContent], {
      type: "text/plain;charset=utf-8",
    });

    // 使用 FileSaver.js 保存 Blob 对象为文件
    fileSaver(blob, "音频超大资源.txt");
  }
  public async table_thread_video_api() {
    let data = await dispatchPkgResourceAbnormalList(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      page: this.video_page,
      size: this.video_size,

      search: this.inputValue3,
      type: "MaxWiseFile",
      is_ignore: this.vedio_is_ignore,
    });
    data.results.forEach((v) => {
      if (v.is_ignore) {
        v.check = true;
      } else {
        v.check = false;
      }
    });
    this.vedio_table = data.results;
    this.vedio_total = data.count;
    this.thread_vedio_loading = false;
  }
  public drawThreadTrend() {
    let data: any = [];

    this.threadTrendData?.type_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.threadTrendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("threadTrend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.threadTrendData?.game_version,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "abnormalResources" + "-" + ".png";
    res.chinese = "异常资源数量统计";
    this.resBase64.push(res);
  }
  public async mapChange() {
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      filename: this.mapFile.join(";"),
    });
    this.mapFile.forEach((v) => {
      this.drawMapStruct(v);
    });
    for (let i = this.resBase64.length - 1; i >= 0; i--) {
      const item = this.resBase64[i];
      if (
        !this.mapFile.some((suffix) =>
          item.chinese.includes(`地图结构-${suffix}`)
        ) &&
        !item.chinese.includes("包体迭代趋势") &&
        !item.chinese.includes("包体结构迭代") &&
        !item.chinese.includes("按类占比分类") &&
        !item.chinese.includes("主资产版本错误引用条数统计")
      ) {
        this.resBase64.splice(i, 1);
      }
    }
    console.log(this.resBase64);
  }
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const _row = this.spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;

      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  publictableRowClassName({ row, rowIndex }) {
    console.log(rowIndex);
  }
  public contrast = true;
  public localProject = Number(getLocalProject()); //得到本地的项目
  public async versionChange(type) {
    this.loading = true;
    if (type === "new") {
      this.thread_trend_loading = true;
      this.thread_max_loading = true;
      this.thread_vedio_loading = true;
      this.inputValue2 = "";
      this.inputValue3 = "";
      this.big_page = 1;
      this.big_size = 10;
      this.video_page = 1;
      this.video_size = 10;
      let version_date = this.listOptions
        .filter((v) => v.id_test == this.id_test)[0]
        .version.split(" ");
      this.formMail.title = `【GR自动化】包体资源深度性能测试报告-${version_date[0]}-${version_date[1]}`;
      if (this.listOptions.length > 1) {
        // this.listOptions.forEach((v,i)=>{if(v.id_test==this.id_test){
        //     return i
        //   }})
        let index_num = 0;
        this.listOptions.forEach((v, i) => {
          if (v.id_test == this.id_test) {
            index_num = i;
          }
        });

        if (index_num == this.listOptions.length - 1) {
          this.old_test = this.listOptions[index_num - 1].id_test;
        } else {
          this.old_test = this.listOptions[index_num + 1].id_test;
        }
      }
      await dispatchPkgTypeRate(store, {
        project: this.localProject,
        id_test: Number(this.id_test),
      });
      await dispatchPkgResourceSum(store, {
        project: this.localProject,
        id_test: Number(this.id_test),
      });
      this.allsize = readGetPkgResourceSum(store);
      // this.thread_trend_api()
      this.table_thread_max_api();
      this.table_thread_video_api();
    }
    this.$router.push({
      query: {
        ...this.$route.query,
        id_test: this.id_test,
        old_test: this.old_test,
      },
    });
    await dispatchPkgMapStructStackOption(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
    });
    this.mapFile =
      this.map_options.length > 0 ? [this.map_options[0].filename] : [];
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      filename: this.mapFile.join(";"),
    });
    this.mapFile.forEach((v) => {
      this.drawMapStruct(v);
    });
    await dispatchPkgResourceReport(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      old_test: Number(this.old_test),
    });
    this.resBase64 = [];
    this.get_core_data = readGetPkgResourceReport(store);
    this.mapsData();
    this.thread_trend_api();
    this.drawTrend();
    this.drawStruct();
    this.drawModular();
    this.drawMisreferenceTrend();
    this.spanArr = [];
    this.getSpanArr(this.top_10);
    this.loading = false;
  }
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public loading = false; //加载
  public RogShow = false;
  public mask_img = "";
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        tdr_risk_rule: {},
      },

      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  public img_index = 0;
  public img_name = "";
  public saveImg = "";
  public imgBtn(i, link, name) {
    this.img_index = i;
    this.img_name = name;
    this.saveImg = link;
  }
  public confirm_btn() {
    this.titleImg = this.saveImg;
    this.test = false;
  }
  //获取核心数据的数据类型
  public get_core_data = {
    base: {
      date: "",
    },
    class_rate: [],
    conclusion: {},
    resource_trend: {
      game_version: [],
      name_list: [],
      series: [],
    },
    misreference_trend: {
      type_list: [],
      game_version: [],
      series: [],
    },
    asset_top10: [],
    map_struct_rate: [],
  };

  //获取场景iD

  // 默认显示11城
  public show = "";
  // 页面初始化
  public get listOptions() {
    return readGetPkgResourceList(store);
  }
  public mapAllSize = 0;
  public mapData = [];
  public mapsData() {
    this.mapAllSize = 0;
    this.mapData = [];
    this.get_core_data.map_struct_rate.forEach((v) => {
      this.mapAllSize += v.size;
      this.mapData.push({ name: v.name, value: v.size });
    });
    console.log(this.mapAllSize);
    this.drawMapModular();
  }
  public spanArr = [];
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].name === data[i - 1].name) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public spanMethod({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.conclusion.filter((item) => item.name === row.name)
        .length;
      if (rowCount > 1) {
        const isFirstRow =
          this.conclusion.findIndex((item) => item.name === row.name) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mapFile = [];
  public async mounted() {
    this.loading = true;
    this.thread_trend_loading = true;
    this.thread_max_loading = true;
    this.thread_vedio_loading = true;
    if (this.$route.query.id_test) {
      await dispatchPkgResourceList(store, {
        project: this.localProject,
      });
      this.listOptions;

      (this.id_test as any) = Number(this.$route.query.id_test);

      (this.old_test as any) = Number(this.$route.query.old_test);
    } else {
      await dispatchPkgResourceList(store, {
        project: this.localProject,
      });
      this.id_test = this.listOptions[0].id_test;
      if (this.listOptions.length > 1) {
        this.old_test = this.listOptions[1].id_test;
      } else {
        this.old_test = this.listOptions[0].id_test;
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          id_test: this.id_test,
          old_test: this.old_test,
        },
      });
    }
    let version_date = this.listOptions
      .filter((v) => v.id_test == this.id_test)[0]
      .version.split(" ");
    this.formMail.title = `【GR自动化】包体资源深度性能测试报告-${version_date[0]}-${version_date[1]}`;
    await dispatchPkgResourceReport(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      old_test: Number(this.old_test),
    });
    this.get_core_data = readGetPkgResourceReport(store);
    this.mapsData();
    await dispatchPkgTypeRate(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
    });
    await dispatchPkgMapStructStackOption(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
    });
    this.mapFile =
      this.map_options.length > 0 ? [this.map_options[0].filename] : [];
    await dispatchPkgMapStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      filename: this.mapFile.join(";"),
    });
    this.mapFile.forEach((v) => {
      this.drawMapStruct(v);
    });
    await dispatchPkgResourceSum(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
    });
    await dispatchPkgStructTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
    });

    this.allsize = readGetPkgResourceSum(store);

    this.thread_trend_api();
    this.table_thread_max_api();
    this.table_thread_video_api();
    this.drawTrend();
    this.drawStruct();
    this.drawModular();
    this.drawMisreferenceTrend();
    this.getSpanArr(this.top_10);
    this.loading = false;
  }
  public drawMapStruct(item) {
    let data: any = [];

    (this.structMapTrendData as any)[item]?.name_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.structMapTrendData as any)[item].series[index],
      });
    });

    let performance_line: any = document.getElementById(item);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.structMapTrendData as any)[item]?.game_version,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = item + "-" + ".png";
    res.chinese = "地图结构-" + item;
    this.resBase64.push(res);
  }
  public get structMapTrendData() {
    return readGetPkgMapStructTrend(store);
  }
  public drawStruct() {
    let data: any = [];

    (this.structTrendData as any)?.name_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.structTrendData as any).series[index],
      });
    });

    let performance_line: any = document.getElementById("struct");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.structTrendData as any)?.game_version,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "struct_trend" + "-" + ".png";
    res.chinese = "包体结构迭代";
    this.resBase64.push(res);
  }
  public get structTrendData() {
    return readGetPkgStructTrend(store)?.trend_data;
  }
  // public get getPerformances() {
  //   //获取性能数据
  //   const performances: any[] = readPerformances(store);
  //   return performances;
  // }
  //性能报告核心数据
  public allsize = 0;
  public test = false;
  public perf_report() {
    this.get_core_data = readPerfReport(store);
  }
  public cellStyle({ row, column, rowIndex, columnIndex }) {
    //指定坐标rowIndex ：行，columnIndex ：列
    // this.getTableColor(row.depth)
    // console.log(columnIndex)
    if (columnIndex === 0) {
      return { background: this.colors[rowIndex], color: "#fff" }; //rgb(105,0,7)
    }
    // return "background:" + this.getTableColor(row.depth); //rgb(105,0,7)
  }
  public get rateData() {
    let list = [];
    let num = 0;
    readGetPkgResourceRate(store).forEach((v, index) => {
      num += v.size;
      list.push({ name: v.name, value: v.size });
    });
    // console.log(list);
    return list;
  }
  // public get mapData() {
  //   let list = [];
  //   let num = 0;
  //   readGetPkgResourceRate(store).forEach((v, index) => {
  //     num += v.size;
  //     list.push({ name: v.name, value: v.size });
  //   });
  //   // console.log(list);
  //   return list;
  // }
  public resources_list = [
    { name: "All", value: "" },
    { name: "待优化", value: "0" },
    { name: "无需优化", value: "1" },
  ];
  public colors = [
    "#5470c6",
    "#91cc75",
    "#fac858",
    "#ee6666",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#935bab",
    "#d872bc",
    "#5470c6",
    "#91cc75",
    "#fac858",
    "#ee6666",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#935bab",
    "#d872bc",
  ];
  public vedio_is_ignore = "0";
  public big_is_ignore = "0";
  public async putCheck(row, type) {
    await dispatchPutAabnormalResourceList(store, {
      project: this.localProject,
      id: row.id,
      is_ignore: row.check ? "1" : "0",
    });
    if (type == "max") {
      this.maxChange(false);
    } else {
      this.videoChange(false);
    }
  }
  public drawModular() {
    // let cilData = this.cilcrt;

    let performance_line: any = document.getElementById("rate") as HTMLElement;
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      title: {
        text: "总大小" + this.sizeCompany(this.allsize),

        left: "center",
      },
      colors: this.colors,
      animation: false,
      // backgroundColor: 'rgb(13, 13, 13)',
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          var str = "";
          //首先要看看params是怎样的数据结构，里面有什么内容;

          //对params进行操作
          return (
            params.data.name +
            ":" +
            this.sizeCompany(params.data.value) +
            "(" +
            params.percent +
            "%)"
          );
        },
      },

      series: [
        {
          type: "pie",
          radius: "80%",
          // center: ["50%", "50%"],
          data: this.rateData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
              },
              labelLine: { show: false },
            },
          },
        },
      ],
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "class_rate" + "-" + ".png";
    res.chinese = "按类占比分类";
    this.resBase64.push(res);
  }
  public drawMapModular() {
    // let cilData = this.cilcrt;

    let performance_line: any = document.getElementById(
      "mapStructure"
    ) as HTMLElement;
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      title: {
        text: "总大小" + this.sizeCompany(this.mapAllSize),

        left: "center",
      },
      colors: this.colors,
      animation: false,
      // backgroundColor: 'rgb(13, 13, 13)',
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          var str = "";
          //首先要看看params是怎样的数据结构，里面有什么内容;

          //对params进行操作
          return (
            params.data.name +
            ":" +
            this.sizeCompany(params.data.value) +
            "(" +
            params.percent +
            "%)"
          );
        },
      },

      series: [
        {
          type: "pie",
          radius: "80%",
          // center: ["50%", "50%"],
          data: this.mapData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
                position: "inside",
                color: "#fff",
              },
              labelLine: { show: false },
            },
          },
        },
      ],
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "map_rate" + "-" + ".png";
    res.chinese = "地图结构-按类占比分类";
    this.resBase64.push(res);
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "B";
      }
      if (Number(item) >= 1024 && Number(item) < 1024 * 1024) {
        return (Number(item) / 1024).toFixed(1) + "KB";
      }
      if (Number(item) >= 1024 * 1024 && Number(item) < 1024 * 1024 * 1024) {
        return (Number(item) / 1024 / 1024).toFixed(1) + "MB";
      }
      if (Number(item) >= 1024 * 1024 * 1024) {
        return (Number(item) / 1024 / 1024 / 1024).toFixed(1) + "GB";
      }
    } else {
      return "";
    }
  }
  public get modular() {
    let list = [];
    readGetPkgResourceReport(store).class_rate.forEach((v) => {
      list.push({ name: v.name, value: v.size });
    });
    return list;
  }
  public titleImg = require("../../assets/performance/recourse.png");
  public risk = "";
  //获取新报告数据
  public get_create_report() {
    this.new_report = readNewReport(store);
    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }

  // 核心指标风险详情
  public corePerformance: any[] = [];
  // 核心指标性能数据

  // 结论

  //将新报告的JSON 字符串转换为对象。
  // public get report_set() {
  //   const settings = JSON.parse(this.new_report.settings);
  //   return settings.report_settings;
  // }

  // 数值变化的规则配置
  // public get rule_set() {
  //   const settings = JSON.parse(this.new_report.settings);
  //   return settings.rule_settings;
  // }
  // 趋势对比
  public drawTrend() {
    let data: any = [];

    this.get_core_data.resource_trend.name_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.get_core_data.resource_trend.series[index],
      });
    });

    let performance_line: any = document.getElementById("chart");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value} MB",
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.get_core_data.resource_trend.game_version,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "resource_trend" + "-" + ".png";
    res.chinese = "包体迭代趋势";
    this.resBase64.push(res);
  }
  public drawMisreferenceTrend() {
    let data: any = [];

    this.get_core_data.misreference_trend.type_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.get_core_data.misreference_trend.series[index],
      });
    });

    let performance_line: any = document.getElementById("mi_chart");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        // axisLabel: {
        //   formatter: "{value} MB",
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.get_core_data.misreference_trend.game_version,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "misreference_trend" + "-" + ".png";
    res.chinese = "主资产版本错误引用条数统计";
    this.resBase64.push(res);
  }
  // 功耗表格趋势对比, 获取差值, type: true为CPU功耗表格, false为CPU/功耗数据
  public compore_power(new_value: number, old_value: number, type: boolean) {
    let color = "#000000";
    let res: any = "";
    if (type) {
      if (!new_value || !old_value || new_value === old_value) {
        return ["", color];
      }
    } else {
      if (!new_value || !old_value || new_value === old_value) {
        return ["--", color];
      }
    }
    res = parseFloat((new_value - old_value).toFixed(1));

    // 指标变化规则判断
    if (type) {
      if (res > 0) {
        color = "red";
        res = "(" + Math.abs(res) + "↑" + ")";
      } else if (res < 0) {
        color = "#00b050";
        res = "(" + Math.abs(res) + "↓" + ")";
      }
    } else {
      if (res > 0) {
        color = "red";
        res = Math.abs(res) + "↑";
      } else if (res < 0) {
        color = "#00b050";
        res = Math.abs(res) + "↓";
      }
    }
    return [res, color];
  }

  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }
  // GPU数据链接
  public get conclusion() {
    let list = [];
    for (let i in this.get_core_data.conclusion) {
      this.get_core_data.conclusion[i].forEach((v) => {
        list.push({
          name: i,
          name1: v.name,
          size: v.size,
          change: v.change,
          level: v.level ? v.level : "",
        });
      });
    }
    // console.log(list);
    return list;
  }

  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }

  //场景选项

  // 获取机型
  public selected_device = "";

  // 指标选项

  //点击切换场景时触发

  public bannerChang() {
    console.log(this.banner_img.filter((v) => v.name == this.banner_name));
  }
  public urls = [];
  public banner_name = "";
  public bannerList = [
    "全部",
    "二次元",
    "科幻",
    "末日废土",
    "欧美魔幻",
    "日系",
    "中国风",
  ];
  public banner_img = [
    {
      name: "二次元",
      value: [
        require("../../assets/performance/AIGCbanner/二次元/two-dimensional_1.png"),
        require("../../assets/performance/AIGCbanner/二次元/two-dimensional_2.png"),
        require("../../assets/performance/AIGCbanner/二次元/two-dimensional_3.png"),
        require("../../assets/performance/AIGCbanner/二次元/two-dimensional_4.png"),
      ],
    },
    {
      name: "科幻",
      value: [
        require("../../assets/performance/AIGCbanner/科幻/Sci-Fi_1.png"),
        require("../../assets/performance/AIGCbanner/科幻/Sci-Fi_2.png"),
      ],
    },
    {
      name: "末日废土",
      value: [
        require("../../assets/performance/AIGCbanner/末日废土/Wasteland_1.png"),
        require("../../assets/performance/AIGCbanner/末日废土/Wasteland_2.png"),
        require("../../assets/performance/AIGCbanner/末日废土/Wasteland_3.png"),
      ],
    },
    {
      name: "欧美魔幻",
      value: [
        require("../../assets/performance/AIGCbanner/欧美魔幻/fantasy_1.png"),
        require("../../assets/performance/AIGCbanner/欧美魔幻/fantasy_2.png"),
      ],
    },
    {
      name: "日系",
      value: [
        require("../../assets/performance/AIGCbanner/日系/japanese_1.png"),
        require("../../assets/performance/AIGCbanner/日系/japanese_2.png"),
      ],
    },
    {
      name: "中国风",
      value: [
        require("../../assets/performance/AIGCbanner/中国风/chinese_1.png"),
        require("../../assets/performance/AIGCbanner/中国风/chinese_2.png"),
        require("../../assets/performance/AIGCbanner/中国风/chinese_3.png"),
        require("../../assets/performance/AIGCbanner/中国风/chinese_4.png"),
        require("../../assets/performance/AIGCbanner/中国风/chinese_5.png"),
      ],
    },
  ];
  // public AIGCbanner=[require('../../assets/performance/AIGCbanner/二次元/two-dimensional_1.png'),require('../../assets/performance/AIGCbanner/二次元/two-dimensional_2.png'),
  // require('../../assets/performance/AIGCbanner/二次元/two-dimensional_3.png'),require('../../assets/performance/AIGCbanner/二次元/two-dimensional_4.png')]
  // public SciFi=[require('../../assets/performance/AIGCbanner/科幻/Sci-Fi_1.png'),require('../../assets/performance/AIGCbanner/科幻/Sci-Fi_2.png'),]
  // public Wasteland=[require('../../assets/performance/AIGCbanner/末日废土/Wasteland_1.png'),require('../../assets/performance/AIGCbanner/末日废土/Wasteland_2.png'),
  // require('../../assets/performance/AIGCbanner/末日废土/Wasteland_3.png')]
  // public fantasy=[require('../../assets/performance/AIGCbanner/欧美魔幻/fantasy_1.png'),require('../../assets/performance/AIGCbanner/欧美魔幻/fantasy_2.png')]
  // public japanese=[require('../../assets/performance/AIGCbanner/日系/japanese_1.png'),require('../../assets/performance/AIGCbanner/日系/japanese_2.png')]
  // public async selectSceneChange1() {
  //   this.resBase64 = [];
  //   this.target_types.map((item, index) => {
  //     this.drawPieChart(index, item.value);
  //   });
  //   this.drawCpuFrequency();
  //   this.drawCPUPowerPieChart();
  // }
  // 点击切换机型的时候触发

  public yAxis: any = {} || [];
  public series: any = [];
  public openBanner() {
    this.test = true;
    this.banner_name = this.bannerList[0];
    // this.img_name=''
  }

  //点击切换指标时触发

  public subChart: any = [];
  //绘制图表准备
  // 原始数据处理

  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  //绘制
  public mark_timeline: string[] = [];

  public drawPieChartShowList = [];
  public target_values_null = [];
  // public  drawPieChartShow(item1){
  //   this.getFPS_RawData.series.forEach((item: any[], i: any) => {
  //     let target_values: any = [];
  //      item.forEach((item) => {
  //       target_values.push(item[this.target_types[item1].value]);
  //     });
  //     this.drawPieChartShowList=target_values
  //   })
  //   if(this.drawPieChartShowList.every((v)=>v!=null)){
  //     return true
  //   }else{
  //     return false
  //   }
  // }
  // 绘制图表

  // 绘制图表

  //报告筛选部分
  //风险等级
  public getColor(text) {
    if (text == "高风险") {
      return "red";
    }
    if (text == "中风险") {
      return "orange";
    }
    if (text == "低风险") {
      return "#00b050";
    }
  }
  public text_show(item) {
    if (item.length >= 1) {
      if (item.length === 1 && item[0] == "avg_fps") {
        return false;
      } else {
        return true;
      }
    }
  }
  public status_search: string | "" = "";
  public status_options = [
    {
      label: "高风险",
      value: "高风险",
    },
    {
      label: "低风险",
      value: "低风险",
    },
  ];
  public save_report() {
    let upload_data: any;
    const result = this.resBase64.reduce((unique, item) => {
      if (!unique.some((obj) => obj.chinese === item.chinese)) {
        unique.push(item);
      }
      return unique;
    }, []);
    upload_data = {
      // project: Number(this.$route.query.project),
      project: this.localProject,
      id_test: this.id_test,
      old_test: this.old_test,

      file_list: result,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,

      send: this.formMail.Sender,
    };
    dispatchUploadPkgReport(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  //报告名称
  public showMask = false;
  public id_test = "";
  public old_test = "";
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 编辑
  public dialogFormVisible1 = false;
  public formLabelWidth = "";
  public form1 = {
    name: "",
  };

  // public showEdit(){
  //   this.dialogFormVisible1 = true;
  //   console.log(this.name_search)
  //   this.form1.name=(readNewReportList(store) as any[]).filter(
  //       (item: any) => item.id === this.name_search
  //     )[0].report_name;
  // }

  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  // 点击删除

  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }
  public get top_10() {
    let list = [];
    for (let i in this.get_core_data.asset_top10) {
      this.get_core_data.asset_top10[i].forEach((v) => {
        list.push({ name: i, func_name: v.name, size: v.size });
      });
    }
    return list;
  }
  public Preview_btn() {
    this.showMask = true;
    this.mask_img = this.saveImg;
    //  this.test=false
  }
  public resBase64: any[] = [];
  //发送报告

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 判断安卓/ios
  public modelVal = "安卓";

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 获取所有的索引

  // 索引分类

  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }
  public trend1 = {};
  // 判断是否出现滚动条
  public scroll = false;
  //   public scrollBar() {
  //     let obj = document.getElementById("Table_Right_div");
  //     if (
  //       this.get_core_data.report_list2.length > 0 &&
  //       (obj as any).offsetHeight - (obj as any).clientHeight > 0
  //     ) {
  //       this.scroll = true;
  //     } else {
  //       this.scroll = false;
  //     }
  //   }

  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }

  // 报告名称切换时

  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称
  public tableData = [
    {
      date: "2016-05-03",
      name: "Tom",
      state: "California",
      city: "Los Angeles",
      address: "No. 189, Grove St, Los Angeles",
      zip: "CA 90036",
      tag: "Home",
    },
    {
      date: "2016-05-02",
      name: "Tom",
      state: "California",
      city: "Los Angeles",
      address: "No. 189, Grove St, Los Angeles",
      zip: "CA 90036",
      tag: "Office",
    },
    {
      date: "2016-05-04",
      name: "Tom",
      state: "California",
      city: "Los Angeles",
      address: "No. 189, Grove St, Los Angeles",
      zip: "CA 90036",
      tag: "Home",
    },
    {
      date: "2016-05-01",
      name: "Tom",
      state: "California",
      city: "Los Angeles",
      address: "No. 189, Grove St, Los Angeles",
      zip: "CA 90036",
      tag: "Office",
    },
  ];
  public getCom(item) {
    let text = "";
    let color = "";
    if (item.indexOf("-") != -1) {
      text = item.replace("-", "↓");
      color = "#00b050";
    } else {
      if (item == "0") {
        text = item;
        color = "";
      } else {
        text = "↑" + item;
        color = "red";
      }
    }
    return [text, color];
  }
  // 打开生成报告
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  //获取下拉选择选项
  // public get getPerformanceSelectOptions() {
  //   return readPerformanceSelectOptions(store);
  // }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    // const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  // GPU数据

  // 生成报告

  // 生成报告

  // 激活报告名称
  // public activation(val: boolean) {
  //   if (val) {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition;
  //   } else {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition.split("|")[0];
  //   }
  // }

  // 得到项目名称
  public maskBtn(ev: any) {
    if (!(this.$refs.mask as any).contains(ev.target)) {
      this.showMask = false;
    }
  }
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }
}
